import React, { useMemo } from "react";
import TeamStreakRow from "../components/TeamStreakRow";

const GameStreak = ({ gameStatistics, team, logoOnRightSide = false }) => {
  // prepare data
  const data = useMemo(() => {
    if (
      !gameStatistics
    ) {
      return null;
    }

    const teamGames = gameStatistics;
    const teamData = teamGames.map((g) => ({
        Score: `${g.ownScore}:${g.otherScore}`,
        AwayTeam: {
          logoUrl: g.otherTeam.logo,
        },
      }));

    return [teamData];
  }, [gameStatistics]);

  return (
    <div className="mx-auto w-fit font-header">
      {data.map((teamStats, index) => (
        <TeamStreakRow
          key={index}
          team={team}
          games={teamStats}
          logoOnRightSide={logoOnRightSide}
        />
      ))}
    </div>
  );
};

export default GameStreak;
